export default "__VITE_ASSET__Cqm3QIVd__"